import React from 'react';
import { useControllableState } from '../../../hooks/useControllableState';
import Combobox from '../combobox/Combobox';

import type { ComboboxItemOnActionParam, ComboboxProps } from '../combobox/Combobox.types';
import { Dropdown } from '../dropdown/Dropdown';

export type DropdownComboboxProps = Omit<
  React.ComponentPropsWithoutRef<typeof Dropdown>,
  'children' | 'onSelect'
> &
  ComboboxProps;

export const DropdownCombobox = (props: DropdownComboboxProps) => {
  const {
    trigger,
    onEscapeKeyDown,
    closeOnSelect,
    onOpenChange,
    defaultOpen,
    open,
    onSelect,
    ...cmdProps
  } = props;
  const [openState, setOpenState] = useControllableState(open, onOpenChange, defaultOpen ?? false);

  const handleEscapeKeyDown = (event: KeyboardEvent) => {
    onOpenChange?.(false);
    onEscapeKeyDown?.(event);
  };

  const handleSelect = (params: ComboboxItemOnActionParam) => {
    if (closeOnSelect) {
      // ref https://stackoverflow.com/questions/77144813/how-to-close-radix-shadcn-popover-from-inside-of-it
      console.warn('TODO: Implement this, like identical/shared across all "dropdown" components');
      setOpenState(false);
    }

    onSelect?.(params);
  };

  return (
    <Dropdown
      variant="dropdown"
      trigger={trigger}
      onEscapeKeyDown={handleEscapeKeyDown}
      onOpenChange={setOpenState}
      open={openState}
    >
      <Combobox onSelect={handleSelect} {...cmdProps} />
    </Dropdown>
  );
};
DropdownCombobox.displayName = 'DropdownCombobox';

export default DropdownCombobox;
